function _classPrivateFieldBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

module.exports = _classPrivateFieldBase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/classPrivateFieldLooseBase.js
// module id = 455
// module chunks = 0